'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from 'react';
import { CampaignCards2up } from './2up';
import { CampaignCards3up } from './3up';
import { CampaignCards4up } from './4up';
import { CampaignCardsInfo } from './info';
import type { CampaignCarsUpProps, CampaignCarsUpVariants } from './types';
const components = {
  info: CampaignCardsInfo,
  '2up': CampaignCards2up,
  '3up': CampaignCards3up,
  '4up': CampaignCards4up
} as Record<CampaignCarsUpVariants, ComponentType<CampaignCarsUpProps>>;
export function CampaignCardsUp(props) {
  const $ = _c(3);
  const Component = components[props.variant] ?? "div";
  let t0;
  if ($[0] !== Component || $[1] !== props) {
    t0 = <Component {...props} />;
    $[0] = Component;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}